import { PlageHoraire } from '../../domain/plage-horaire';
import { mapper } from '../../tools/mapping/mapper';
import { PlageHoraireEntity } from '../entity';
import type { AppDB } from '../db';

export class PlageHoraireRepository {
    constructor(private readonly database: AppDB) {}


    async getPlageHoraireEntityById(id: number) {
        return await this.database.plageHoraires.where('Id').equals(id).first(async pe => {
            return pe;
        });
    }

    async clearPlageHoraireById(ids: number[]) {
        await this.database.plageHoraires.where('Id').anyOf(ids).toArray(async phe => {
            for (let i = 0; i < phe.length; i++) {
                if (phe && phe[i].Id !== undefined) {
                    await this.database.plageHoraires.where('Id').equals(phe[i].Id!).delete();
                }
            }
        })
    }

    async attachPlageHoraire(plageHoraire: PlageHoraire, cassetteId: number) {
        let plageHoraireId: number;
        const phe = mapper.map(plageHoraire, PlageHoraire, PlageHoraireEntity);

        const ce = await this.database.getCassetteEntityById(cassetteId);
        plageHoraireId = await this.database.plageHoraires.add(phe);
        await this.database.cassettes.update(cassetteId, {
            PlageHoraireIds: ce?.PlageHoraireIds ? [...ce.PlageHoraireIds, plageHoraireId] : [plageHoraireId]
        });
        return plageHoraireId;

    }
}
